<form class="login-form" (submit)="onSubmit($event)">
  <dx-form [formData]="formData" [disabled]="loading" [showColonAfterLabel]="true" [showRequiredMark]="false">
    <dxi-item
      dataField="email"
      editorType="dxTextBox"
      [editorOptions]="{
        placeholder: 'Email',
        stylingMode: 'filled',
        mode: 'email',
        value: defaultAuthData?.data?.email
      }"
    >
      <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
      <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
      <dxo-label [visible]="false"></dxo-label>
    </dxi-item>

    <dxi-item [label]="{ visible: false }">
      <dx-text-box
        *dxTemplate
        [(value)]="formData.password"
        [placeholder]="'Password'"
        [mode]="'password'"
        [showClearButton]="true"
        [stylingMode]="'filled'"
      >
        <dx-validator>
          <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </dxi-item>

    <dxi-item itemType="button">
      <dxo-button-options width="100%" type="default" cssClass="btn-sign-in" [useSubmitBehavior]="true" [template]="'signInTemplate'">
      </dxo-button-options>
    </dxi-item>

    <ng-container *dxTemplate="let item of 'signInTemplate'">
      <span class="dx-button-text">
        <ng-container *ngIf="loading; else notLoading">
          <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
        </ng-container>
        <ng-template #notLoading>Sign In</ng-template>
      </span>
    </ng-container>
  </dx-form>
</form>
